import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../../Layout/Layout';
import { Container, Row, Col } from 'reactstrap';
import TitleBar from '../../Layout/TitleBar';
import {
  CookbookMealListEdge,
  withLoading,
  callNativeMobileApp,
} from '@front-activerse/common-components';
import CookbookMealItem from '../components/CookbookMealItem';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';

interface ICookbookTagMealsContainer {
  tagName: string;
  tagType: string;
  tagId: string;
  meals: CookbookMealListEdge[];
  addToFavorites: (mealId: number) => Promise<unknown>;
  removeFromFavorites: (mealId: number) => Promise<unknown>;
}

export const CookbookTagMealsContainer: React.FC<ICookbookTagMealsContainer> = ({
  tagName,
  tagType,
  tagId,
  meals,
  addToFavorites,
  removeFromFavorites,
}) => {
  const location = useLocation();

  useEffect(() => {
    if (tagName) {
      if (window.location.pathname.includes('meals-by-tag')) {
        callNativeMobileApp({
          action: 'title_changed',
          payload: {
            title: tagName,
          },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagType, tagId, location]);

  return (
    <Layout>
      <TitleBar level={1}>{tagName}</TitleBar>
      <div className="page-template-cookbook full-height3">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="cookbook-category">
                  <Row className="cookbook-meals">
                    {meals.map(({ node }) => (
                      <CookbookMealItem
                        key={node.id}
                        {...node}
                        addToFavorites={addToFavorites}
                        removeFromFavorites={removeFromFavorites}
                        orientation="horizontal"
                      />
                    ))}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder titleBar="" />;

export default withLoading(CookbookTagMealsContainer, Placeholder);
